import React, { useContext, useEffect, useReducer, useRef, useState } from 'react';
import { faFolder, faCheck, faDoorOpen, faUserCog, faUserEdit, faArchive, faClock, faChartLine, faUserGear, faCog } from "@fortawesome/free-solid-svg-icons";
import ClickOutside from 'react-click-outside';
import api from './api';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from './img/kre-sans-texte.png';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { fr } from 'date-fns/locale'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import Sidenav from './component/Sidenav';
import TimesheetsView from './Admin/TimesheetsView';
import EmployeeListView from './Admin/EmployeeListView';
import EmployeeDetailsView from './Admin/EmployeeDetailsView';
import TimeEntryDetailsView from './Admin/TimeEntryDetailsView';
import SettingsView from './Admin/SettingsView';
import Dashboard from './Admin/Dashboard';
import AppDrawer from './component/AppDrawer';
const MainApp = (props) => {

    const user = null;//useContext(UserContext)
    const [barOpen, setBarOpen] = useState(false)

    const deconnect = () => {
        localStorage.clear();
        window.location.reload();
        window.location.href = "/"
    }

    const links = [
        { text: "Feuilles de temps", icon: <FontAwesomeIcon icon={faClock} />, path: "/timesheets", type: "link" },
        { text: "Employés", icon: <FontAwesomeIcon icon={faUserGear} />, path: "/admin", type: "link" },
        { text: "Tableau de bord", icon: <FontAwesomeIcon icon={faChartLine} />, path: "/dashboard", type: "link" },
        { text: "Paramètres", icon: <FontAwesomeIcon icon={faCog} />, path: "/settings", type: "link" },
    ]

    return (
        <Router>
            <AppDrawer links={links} user={user} logoff={deconnect}>
                <LocalizationProvider locale={fr} dateAdapter={AdapterDateFns}>
                    <Routes>
                        <Route exact path="/" element={<Navigate to="/timesheets" />}>
                        </Route>
                        <Route path="/timesheets" element={<TimesheetsView />} />
                        <Route path="/admin" element={<EmployeeListView />} />
                        <Route path="/admin/employee/:employeeID" element={<EmployeeDetailsView />} />
                        <Route path="/admin/employee/" element={<EmployeeDetailsView />} />
                        <Route path="/settings/" element={<SettingsView />} />
                        <Route path="/dashboard/" element={<Dashboard />} />
                        <Route path="/timeentry/" element={<TimeEntryDetailsView />} />
                    </Routes>
                </LocalizationProvider>
            </AppDrawer>
        </Router>
    )

}

export default MainApp;